import cache from '@src/internal/cache';
import { observable } from 'mobx';
import { Store } from '.';

export enum UserStatusType {
    NORMAL = 100,
    NO_SIGN = 200,
    NO_REAL_NAME = 300
}

class User {
    @observable token = cache.getToken();

    @observable rootStore: Store = null;

    @observable userStatus: UserStatusType = UserStatusType.NORMAL;

    constructor(rootStore: Store) {
        this.rootStore = rootStore;
    }

    setToken(token: string) {
        cache.setToken(token);
        this.token = token;
    }

    removeToken() {
        cache.removeToken();
        this.token = '';
    }

    setUserStatus(status: UserStatusType) {
        this.userStatus = status;
    }
}

export default User;
